import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { Physicals } from '../../canvas/entities/Physicals';
import { RoadmapCard } from './RoadmapCard';

export const createRoadmapCard = defineCommand(
    'createRoadmapCard',
    'Create: Roadmap Card',
    (r) => {
        Physicals.createAtCameraPosition(r, RoadmapCard, nc => {
            nc.label = 'Roadmap Item';
            nc.width = 500;
            nc.height = 80;
        });
    },
);
